// extracted by mini-css-extract-plugin
export var closeButton = "_lz-1";
export var closeX = "_lz-3";
export var container = "_lz-0";
export var image = "_lz-2";